export default {
	orderBy: "Id",
	disableProductSorter: false,
	pageSize: 12
};
